export type Log = LogEntry[];

export const MAX_LOG_LIMIT = 32;

export type LogStatus = "IMPORTANT" | "MESSAGE" | "ERROR" | "CRITICAL_WARNING" | "WARNING" | "CLEAR";

export const logIntroMessage = "Welcome to Higharc Studio!";

export function isWarningOrErrorLog(status: LogStatus) {
  return ["ERROR", "WARNING"].includes(status);
}

export interface LogEntry {
  readonly status: LogStatus;
  readonly text: string;
  readonly title?: string;
  readonly timestamp: Date;
  readonly logType: "SYSTEM" | "BUILDING_GENERATION" | "CLIPBOARD";
  readonly logLabel?: string;
  readonly docRefs?: { [key: string]: string };
}

type LogEntryText = string | { title: string; text: string };

export function newLog(
  text: LogEntryText,
  status: LogEntry["status"],
  logType: LogEntry["logType"] = "BUILDING_GENERATION",
): LogEntry {
  if (typeof text === "object") {
    return {
      title: text.title,
      text: text.text,
      status,
      timestamp: new Date(),
      logType,
    };
  }

  return { text, status, timestamp: new Date(), logType };
}

export function logImportant(
  log: Log,
  text: LogEntryText | undefined,
  logType: LogEntry["logType"] = "BUILDING_GENERATION",
): LogEntry[] {
  if (!text) {
    return log;
  }

  if (typeof text === "object") {
    return [
      ...log,
      {
        status: "IMPORTANT",
        title: text.title,
        text: text.text,
        timestamp: new Date(),
        logType,
      },
    ];
  }

  return [...log, { status: "IMPORTANT", text, timestamp: new Date(), logType }];
}

export function logMessage(
  log: Log,
  text: LogEntryText | undefined,
  logType: LogEntry["logType"] = "BUILDING_GENERATION",
): LogEntry[] {
  if (!text) {
    return log;
  }

  if (typeof text === "object") {
    return [
      ...log,
      {
        status: "MESSAGE",
        title: text.title,
        text: text.text,
        timestamp: new Date(),
        logType,
      },
    ];
  }

  return [...log, { status: "MESSAGE", text, timestamp: new Date(), logType }];
}

export function logWarning(
  log: Log,
  text: LogEntryText | undefined,
  logType: LogEntry["logType"] = "BUILDING_GENERATION",
): LogEntry[] {
  if (!text) {
    return log;
  }

  if (typeof text === "object") {
    return [
      ...log,
      {
        status: "WARNING",
        title: text.title,
        text: text.text,
        timestamp: new Date(),
        logType,
      },
    ];
  }

  return [...log, { status: "WARNING", text, timestamp: new Date(), logType }];
}

export function logError(
  log: Log,
  text: LogEntryText | undefined,
  logType: LogEntry["logType"] = "BUILDING_GENERATION",
): LogEntry[] {
  if (!text) {
    return log;
  }

  if (typeof text === "object") {
    return [
      ...log,
      {
        status: "ERROR",
        title: text.title,
        text: text.text,
        timestamp: new Date(),
        logType,
      },
    ];
  }

  return [...log, { status: "ERROR", text, timestamp: new Date(), logType }];
}
